import request from './request'

function currentUser() {
    try {
        const user = JSON.parse(localStorage.getItem('user') || '{}')
        const accountType = firstValue(
            user.accountType,
            user.account_type,
            user.userType,
            user.user_type,
            user.type
        )
        const username = user.username || ''
        const isAdmin = isAdminUser(user, accountType, username)
        return {
            userId: user.id || user.userId ? String(user.id || user.userId) : '',
            username,
            accountType: accountType !== undefined && accountType !== null ? String(accountType) : '',
            isAdmin
        }
    } catch (e) {
        return {
            userId: '',
            username: '',
            accountType: '',
            isAdmin: false
        }
    }
}

function firstValue() {
    for (let i = 0; i < arguments.length; i += 1) {
        const value = arguments[i]
        if (value !== undefined && value !== null && value !== '') {
            return value
        }
    }
    return undefined
}

function isTrue(value) {
    return value === true || value === 1 || String(value).toLowerCase() === 'true'
}

function isAdminUser(user, accountType, username) {
    const role = String(user.role || user.userRole || '').toLowerCase()
    const name = String(username || '').toLowerCase()
    return String(accountType) === '1'
        || isTrue(user.admin)
        || isTrue(user.isAdmin)
        || role === 'admin'
        || role === 'administrator'
        || name === 'admin'
        || name === 'administrator'
}

function withCurrentUserParams(params) {
    const user = currentUser()
    return Object.assign({}, params || {}, {
        currentUserId: user.userId,
        currentUsername: user.username,
        currentAccountType: user.accountType,
        currentIsAdmin: user.isAdmin
    })
}

function withCurrentUserData(data) {
    const user = currentUser()
    return Object.assign({}, data || {}, {
        creatorUserId: (data && data.creatorUserId) || user.userId,
        createdBy: (data && data.createdBy) || user.username
    })
}

function withFavoriteUserData(data) {
    const user = currentUser()
    return Object.assign({}, data || {}, {
        userId: (data && data.userId) || user.userId,
        username: (data && data.username) || user.username,
        currentAccountType: user.accountType,
        currentIsAdmin: user.isAdmin
    })
}

function withOperatorUserData(data) {
    const user = currentUser()
    return Object.assign({}, data || {}, {
        operatorUserId: (data && data.operatorUserId) || user.userId,
        operatorUsername: (data && data.operatorUsername) || user.username,
        currentAccountType: user.accountType,
        currentIsAdmin: user.isAdmin
    })
}

export function listAigcProviderConfigs() {
    return request({
        url: '/aigc/provider-configs',
        method: 'get',
        withCredentials: false
    })
}

export function saveAigcProviderConfig(provider, data) {
    return request({
        url: `/aigc/provider-configs/${provider}`,
        method: 'put',
        withCredentials: false,
        data
    })
}

export function listAigcProviderKeys(provider) {
    return request({
        url: `/aigc/provider-configs/${provider}/keys`,
        method: 'get',
        withCredentials: false
    })
}

export function saveAigcProviderKey(provider, data) {
    return request({
        url: `/aigc/provider-configs/${provider}/keys`,
        method: 'post',
        withCredentials: false,
        data
    })
}

export function deleteAigcProviderKey(id) {
    return request({
        url: `/aigc/provider-configs/keys/${id}`,
        method: 'delete',
        withCredentials: false
    })
}

export function listAigcVideoModelConfigs(provider) {
    return request({
        url: '/aigc/video-model-configs',
        method: 'get',
        withCredentials: false,
        params: { provider }
    })
}

export function saveAigcVideoModelConfig(provider, data) {
    return request({
        url: `/aigc/video-model-configs/${provider}`,
        method: 'post',
        withCredentials: false,
        data
    })
}

export function deleteAigcVideoModelConfig(id) {
    return request({
        url: `/aigc/video-model-configs/${id}`,
        method: 'delete',
        withCredentials: false
    })
}

export function getVideoStorageConfig() {
    return request({
        url: '/video-storage/config',
        method: 'get',
        withCredentials: false
    })
}

export function saveVideoStorageConfig(data) {
    return request({
        url: '/video-storage/config',
        method: 'put',
        withCredentials: false,
        data
    })
}

export function uploadAigcReferenceMedia(file, options) {
    const formData = new FormData()
    const user = currentUser()
    formData.append('file', file)
    if (options && options.mediaType) formData.append('mediaType', options.mediaType)
    formData.append('uploaderUserId', (options && options.uploaderUserId) || user.userId)
    formData.append('uploadedBy', (options && options.uploadedBy) || user.username)
    return request({
        url: '/aigc/media/upload',
        method: 'post',
        withCredentials: false,
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData
    })
}

export function listAigcReferenceMedia(params) {
    return request({
        url: '/aigc/media/assets',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}

export function downloadAigcImagesZip(data) {
    return request({
        url: '/aigc/media/download-images',
        method: 'post',
        withCredentials: false,
        responseType: 'blob',
        timeout: 600000,
        data
    })
}

export function generateAigcImage(data) {
    return request({
        url: '/aigc/images/generate',
        method: 'post',
        withCredentials: false,
        timeout: 600000,
        data: withCurrentUserData(data)
    })
}

export function submitAigcImage(data) {
    return request({
        url: '/aigc/images/submit',
        method: 'post',
        withCredentials: false,
        timeout: 60000,
        data: withCurrentUserData(data)
    })
}

export function createAigcImageSchedule(data) {
    return request({
        url: '/aigc/images/schedules',
        method: 'post',
        withCredentials: false,
        data: withCurrentUserData(data)
    })
}

export function listAigcImageSchedules(params) {
    return request({
        url: '/aigc/images/schedules',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}

export function cancelAigcImageSchedule(id) {
    return request({
        url: `/aigc/images/schedules/${id}/cancel`,
        method: 'post',
        withCredentials: false,
        params: withCurrentUserParams({})
    })
}

export function listAigcImageTasks(params) {
    return request({
        url: '/aigc/images/tasks',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}

export function listUploadedVideoRecords(params) {
    return request({
        url: '/api/tiktok/video/v2/records',
        method: 'get',
        withCredentials: false,
        params
    })
}

export function createAigcVideoTask(data) {
    return request({
        url: '/aigc/videos/tasks',
        method: 'post',
        withCredentials: false,
        data: withCurrentUserData(data)
    })
}

export function listAigcVideoTasks(params) {
    return request({
        url: '/aigc/videos/tasks',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}

export function getAigcVideoBillingSummary(params) {
    return request({
        url: '/aigc/videos/billing/summary',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}

export function estimateAigcVideoBilling(data) {
    return request({
        url: '/aigc/videos/billing/estimate',
        method: 'post',
        withCredentials: false,
        data
    })
}

export function setAigcVideoTaskFavorite(id, data) {
    return request({
        url: `/aigc/videos/tasks/${id}/favorite`,
        method: 'post',
        withCredentials: false,
        data: withFavoriteUserData(data)
    })
}

export function syncAigcVideoTask(id, operator) {
    const user = currentUser()
    return request({
        url: `/aigc/videos/tasks/${id}/sync`,
        method: 'post',
        withCredentials: false,
        params: {
            operator: operator || user.username,
            currentUserId: user.userId,
            currentUsername: user.username
        }
    })
}

export function cancelAigcVideoTask(id, operator) {
    const user = currentUser()
    return request({
        url: `/aigc/videos/tasks/${id}/cancel`,
        method: 'post',
        withCredentials: false,
        params: {
            operator: operator || user.username,
            currentUserId: user.userId,
            currentUsername: user.username
        }
    })
}

export function listAigcVideoTaskEvents(id) {
    return request({
        url: `/aigc/videos/tasks/${id}/events`,
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams()
    })
}

export function listAigcVideoTaskShares() {
    return request({
        url: '/aigc/videos/shares',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams()
    })
}

export function saveAigcVideoTaskShares(data) {
    const user = currentUser()
    return request({
        url: '/aigc/videos/shares',
        method: 'put',
        withCredentials: false,
        data: Object.assign({}, data || {}, {
            operatorUserId: user.userId,
            operatorUsername: user.username
        })
    })
}

export function listAigcUserGroups(params) {
    return request({
        url: '/aigc/user-groups',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}

export function saveAigcUserGroup(data) {
    return request({
        url: '/aigc/user-groups',
        method: 'post',
        withCredentials: false,
        data: withOperatorUserData(data)
    })
}

export function saveAigcUserGroupQuotas(groupId, data) {
    return request({
        url: `/aigc/user-groups/${groupId}/quotas`,
        method: 'put',
        withCredentials: false,
        data: withOperatorUserData(data)
    })
}

export function getAigcQuotaProgress(params) {
    return request({
        url: '/aigc/user-groups/quota-progress',
        method: 'get',
        withCredentials: false,
        params: withCurrentUserParams(params)
    })
}
